import type { EntityType } from 'types/entityType';

export const ENTITY_TYPE: EntityType = 'battery';

export const TEST_ID = 'batteryMultiSelectPanelField';
